import React, { useContext, useState, useEffect } from 'react';

//contexts
import { myUserDataContext } from '../../../App';

//functions
import { responseHandler } from '../../../functions/responseHandler';

//dependencys
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import axios from 'axios';

//components
import Loading from '../../../shared/Loading';
import ModalYesorNo from '../../../shared/ModalYesorNo';
import ShowNothing from '../../../shared/ShowNothing';
import DownloadExcelModal from '../../../shared/DownloadExcelModal';

//shared
import MyPagination from '../../../shared/MyPagination';

//styles
import styles from './ShowLandings.module.scss';

import DatePicker, { DateObject } from 'react-multi-date-picker';
import InputIcon from 'react-multi-date-picker/components/input_icon';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import CustomSelect from 'react-select';
import { debounce } from 'lodash';
import CopyLandingModal from './CopyLandingModal';

const ShowLandings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = queryString.parse(location.search);

  const data = useContext(myUserDataContext);
  const { userData, isLogin, mainUrl, keySearch } = data;
  const { token } = userData;

  const [AllLandings, setAllLandings] = useState([]);
  const [copyId, setCopyId] = useState(null);
  const [isLoad, setIsLoad] = useState(true);
  const [metaPages, setMetaPage] = useState({});
  const [UpdateListLandings, setUpdateListLandings] = useState(false);

  const [sortTable, setSortTable] = useStateWithCallbackLazy(
    queryParams.order_by ? getSortValue(queryParams) : '1'
  );
  const [automation, setAutomation] = useState(
    queryParams.is_automate || 'all'
  );
  const [startAt, setStartAt] = useState(
    queryParams.created_start || null
  );
  const [endAt, setEndAt] = useState(queryParams.created_end || null);
  const [slugSearch, setSlugSearch] = useState(
    queryParams.slug || ''
  );
  const [minValue, setMinValue] = useState(
    queryParams.min_views || ''
  );
  const [titleSearch, setTitleSearch] = useState(
    queryParams.title || ''
  );
  const [tokenSearch, setTokenSearch] = useState(
    queryParams.token || ''
  );
  const [typeSearch, setTypeSearch] = useState(
    queryParams.type || ''
  );
  const [userSearch, setUserSearch] = useState(
    queryParams.user_id
      ? { value: queryParams.user_id, label: '' }
      : null
  );
  const [templateSearch, setTemplateSearch] = useState(
    queryParams.template_id
      ? { value: queryParams.template_id, label: '' }
      : null
  );
  const [template, setTemplate] = useState([]);
  const [users, setUsers] = useState([]);

  function getSortValue(params) {
    if (params.order_by === 'statistic' && params.sort === 'desc')
      return '2';
    if (params.order_by === 'statistic' && params.sort === 'asc')
      return '3';
    if (params.order_by === 'online_client' && params.sort === 'desc')
      return '4';
    if (params.order_by === 'online_client' && params.sort === 'asc')
      return '5';
    if (params.order_by === 'ctr' && params.sort === 'desc')
      return '6';
    if (params.order_by === 'ctr' && params.sort === 'asc')
      return '7';
    return '1';
  }
  let joinqueries = [];
  for (let item in queryParams) {
    if (item === 'page') continue;
    const temp = `${item}=${queryParams[item]}`;
    joinqueries.push(temp);
  }
  joinqueries = joinqueries.join('&');

  useEffect(() => {
    setIsLoad(true);
    axios
      .get(
        `/landing/index?page=${
          queryParams.page || 1
        }&relations[]=template&relations[]=user${
          joinqueries !== '' ? `&${joinqueries}` : ''
        }`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setAllLandings(res.data.data);
          setIsLoad(false);
          setMetaPage(res.data.meta);
        }
      })
      .catch((error) => {
        responseHandler(error, 'error');
      });
  }, [UpdateListLandings, keySearch, joinqueries, location.search]);

  const deleteTemplateHandler = (id) => {
    axios
      .delete(`landing/delete/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        responseHandler(res, 'succ');
        if (res.data.status) {
          setUpdateListLandings(!UpdateListLandings);
          navigate(`/dashboard/showLandings`);
        }
      })
      .catch((error) => {
        responseHandler(error, 'error');
      });
  };

  const paginationHandler = (url) => {
    setIsLoad(true);
    axios
      .get(
        `/landing/index?page=${url}&relations[]=template&relations[]=user${
          joinqueries !== '' ? `&${joinqueries}` : ''
        }`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setAllLandings(res.data.data);
          setIsLoad(false);
          setMetaPage(res.data.meta);
        }
      })
      .catch((error) => {
        responseHandler(error, 'error');
      });
  };

  if (AllLandings.length) {
    var length = metaPages.links.length;
  }
  const myPath = '/dashboard/showLandings';

  const buildQueryString = (
    sortValue,
    automationValue,
    startDate,
    endDate,
    titleValue,
    slugValue,
    minimumValue,
    typeValue,
    tokenValue,
    templateValue,
    userValue
  ) => {
    const queryParams = {};

    if (sortValue === '2') {
      queryParams.order_by = 'statistic';
      queryParams.sort = 'desc';
    } else if (sortValue === '3') {
      queryParams.order_by = 'statistic';
      queryParams.sort = 'asc';
    } else if (sortValue === '4') {
      queryParams.order_by = 'online_client';
      queryParams.sort = 'desc';
    } else if (sortValue === '5') {
      queryParams.order_by = 'online_client';
      queryParams.sort = 'asc';
    } else if (sortValue === '6') {
      queryParams.order_by = 'ctr';
      queryParams.sort = 'desc';
    } else if (sortValue === '7') {
      queryParams.order_by = 'ctr';
      queryParams.sort = 'asc';
    }

    if (automationValue === 'automatic') {
      queryParams.is_automate = 'true';
    } else if (automationValue === 'manual') {
      queryParams.is_automate = 'false';
    }

    if (startDate) {
      queryParams.created_start = startDate;
    }
    if (endDate) {
      queryParams.created_end = endDate;
    }

    if (
      titleValue &&
      typeof titleValue === 'string' &&
      titleValue.trim() !== ''
    ) {
      queryParams.title = titleValue.trim();
    }
    if (
      slugValue &&
      typeof slugValue === 'string' &&
      slugValue.trim() !== ''
    ) {
      queryParams.slug = slugValue.trim();
    }
    if (
      minimumValue &&
      typeof minimumValue === 'string' &&
      minimumValue.trim() !== ''
    ) {
      queryParams.min_views = minimumValue.trim();
    }
    if (
      typeValue &&
      typeof typeValue === 'string' &&
      typeValue.trim() !== ''
    ) {
      queryParams.type = typeValue.trim();
    }
    if (
      tokenValue &&
      typeof tokenValue === 'string' &&
      tokenValue.trim() !== ''
    ) {
      queryParams.token = tokenValue.trim();
    }

    if (templateValue && templateValue.value) {
      queryParams.template_id = templateValue.value;
    }
    if (userValue && userValue.value) {
      queryParams.user_id = userValue.value;
    }

    return queryParams;
  };

  const handleTitleSearch = (e) => {
    setTitleSearch(e.target.value);
  };

  const handleSlugSearch = (e) => {
    setSlugSearch(e.target.value);
  };

  const handleMinValue = (e) => {
    setMinValue(e.target.value);
  };

  const handleTokenSearch = (e) => {
    setTokenSearch(e.target.value);
  };

  const handleTypeSearch = (e) => {
    setTypeSearch(e.target.value);
  };

  const fetchTemplates = async (title = '') => {
    try {
      const url = title
        ? `/template/list-for-select?title=${encodeURIComponent(
            title
          )}`
        : `/template/list-for-select`;

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.status) {
        const options = res.data.data.map((item) => ({
          label: item.title,
          value: item.id,
        }));
        setTemplate(options);
      }
    } catch (err) {
      responseHandler(err, 'error');
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  const debouncedFetch = debounce((value) => {
    if (value.length >= 2) {
      fetchTemplates(value);
    }
  }, 500);

  const handleInputChange = (value) => {
    debouncedFetch(value);
  };

  const handleChangeTemplate = (selectedOption) => {
    setTemplateSearch(selectedOption);
  };

  console.log('check cicd22');

  const fetchUsers = async () => {
    try {
      const url = `/user/list-for-select`;

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.status) {
        const options = res.data.data.map((item) => ({
          label: item.last_name,
          value: item.id,
        }));
        setUsers(options);
      }
    } catch (err) {
      responseHandler(err, 'error');
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const debouncedFetchUsers = debounce((value) => {
    if (value.length >= 2) {
      fetchUsers(value);
    }
  }, 500);

  const handleInputChangeUser = (value) => {
    debouncedFetchUsers(value);
  };

  const handleChangeUser = (selectedOption) => {
    setUserSearch(selectedOption);
  };

  const handleSearchSubmit = () => {
    const queryParams = buildQueryString(
      sortTable,
      automation,
      startAt,
      endAt,
      titleSearch,
      slugSearch,
      minValue,
      typeSearch,
      tokenSearch,
      templateSearch,
      userSearch
    );

    navigate({
      pathname: '/dashboard/showLandings',
      search: queryString.stringify(queryParams),
    });

    document.getElementById('closeFilterModal').click();
  };
  const handleResetFilters = () => {
    setSortTable('1');
    setAutomation('all');
    setStartAt(null);
    setEndAt(null);
    setTitleSearch('');
    setSlugSearch('');
    setMinValue('');
    setTokenSearch('');
    setTypeSearch('');
    setTemplateSearch(null);
    setUserSearch(null);
  };

  const formatDateTime = (dateObj) => {
    const d = dateObj.toDate();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  return !isLoad && isLogin ? (
    <>
      <button
        data-bs-toggle="modal"
        data-bs-target="#newFilterModal"
        style={{ marginLeft: 20, color: '#fff' }}
        className="btn btn-success btn-sm"
      >
        <i className="bi bi-file-spreadsheet-fill me-2"></i>
        <span> فیلتر پیشرفته</span>
      </button>
      <div
        className="modal fade"
        id="newFilterModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog  modal-dialog-centered ">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                فیلتر پیشرفته{' '}
              </h1>
            </div>
            <div className="modal-body">
              <div className={styles.divNewUser}>
                <>
                  <div
                    style={{
                      display: 'flex',
                      marginBottom: 20,
                    }}
                  >
                    <div style={{ width: '50%', margin: 10 }}>
                      <select
                        className="form-select"
                        value={sortTable}
                        onChange={(e) => setSortTable(e.target.value)}
                      >
                        <option value="1" defaultChecked>
                          ترتیب پیشفرض
                        </option>
                        <option value="2">
                          بیشترین تعداد بازدید
                        </option>
                        <option value="3">کمترین تعداد بازدید</option>
                        <option value="4">بیشترین آنلاینی ها</option>
                        <option value="5">کمترین آنلاینی ها</option>
                        <option value="6">بیشترین ctr</option>
                        <option value="7">کمترین ctr</option>
                      </select>
                    </div>
                    <div style={{ width: '50%', margin: 10 }}>
                      <select
                        className="form-select"
                        value={automation}
                        onChange={(e) =>
                          setAutomation(e.target.value)
                        }
                      >
                        <option value="all" defaultChecked>
                          همه
                        </option>
                        <option value="automatic">اتوماتیک</option>
                        <option value="manual">دستی</option>
                      </select>
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      marginBottom: 20,
                    }}
                  >
                    {template?.length > 0 && (
                      <>
                        <div
                          style={{
                            width: '50%',
                            margin: 10,
                          }}
                        >
                          <CustomSelect
                            options={template}
                            placeholder="قالب را انتخاب کنید"
                            onInputChange={handleInputChange}
                            onChange={handleChangeTemplate}
                            isClearable
                            isSearchable
                            value={templateSearch}
                          />
                        </div>
                      </>
                    )}
                    {users?.length > 0 && (
                      <>
                        <div
                          style={{
                            width: '50%',
                            margin: 10,
                          }}
                        >
                          <CustomSelect
                            options={users}
                            placeholder="کاربر را انتخاب کنید"
                            onInputChange={handleInputChangeUser}
                            onChange={handleChangeUser}
                            isClearable
                            isSearchable
                            value={userSearch}
                          />
                        </div>
                      </>
                    )}
                  </div>

                  <div
                    style={{
                      display: 'flex',
                    }}
                  >
                    <input
                      style={{
                        backgroundColor: '#fff',
                        borderRadius: 10,
                        width: '50%',
                        margin: 10,
                        padding: 10,
                      }}
                      type="text"
                      placeholder="نام لندینگ ..."
                      value={titleSearch}
                      onChange={handleTitleSearch}
                    />

                    <input
                      style={{
                        backgroundColor: '#fff',
                        borderRadius: 10,
                        width: '50%',
                        margin: 10,
                        padding: 10,
                      }}
                      type="text"
                      placeholder="آدرس ..."
                      value={slugSearch}
                      onChange={handleSlugSearch}
                    />
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      marginBottom: 20,
                    }}
                  >
                    <input
                      style={{
                        backgroundColor: '#fff',
                        borderRadius: 10,
                        width: '50%',
                        margin: 10,
                        padding: 10,
                      }}
                      type="text"
                      placeholder="تایپ ..."
                      value={typeSearch}
                      onChange={handleTypeSearch}
                    />
                    <input
                      style={{
                        backgroundColor: '#fff',
                        borderRadius: 10,
                        width: '50%',
                        margin: 10,
                        padding: 10,
                      }}
                      type="text"
                      placeholder="توکن ..."
                      value={tokenSearch}
                      onChange={handleTokenSearch}
                    />
                  </div>

                  <div style={{ display: 'flex' }}>
                    <div
                      style={{
                        marginLeft: 20,
                        marginRight: 10,
                        marginBottom: 20,
                        width: '50%',
                      }}
                    >
                      <p>تاریخ شروع</p>

                      <DatePicker
                        value={
                          startAt ? new DateObject(startAt) : null
                        }
                        placeholder="تاریخ شروع"
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        format="YYYY/MM/DD"
                        render={
                          <InputIcon className={styles.inputDate} />
                        }
                        className="red"
                        maxDate={new DateObject({
                          calendar: persian,
                        }).add(0, 'days')}
                        onChange={(date) => {
                          setStartAt(
                            date ? formatDateTime(date) : null
                          );
                        }}
                      />
                    </div>
                    <div
                      style={{
                        marginLeft: 20,
                        marginBottom: 40,
                        width: '50%',
                      }}
                    >
                      <p>تاریخ پایان</p>

                      <DatePicker
                        value={endAt ? new DateObject(endAt) : null}
                        placeholder="تاریخ پایان"
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        format="YYYY/MM/DD"
                        render={
                          <InputIcon className={styles.inputDate} />
                        }
                        className="red"
                        maxDate={new DateObject({
                          calendar: persian,
                        }).add(0, 'days')}
                        onChange={(date) => {
                          setEndAt(
                            date ? formatDateTime(date) : null
                          );
                        }}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      margin: 1,
                    }}
                  >
                    <input
                      style={{
                        backgroundColor: '#fff',
                        borderRadius: 10,
                        width: '70%',
                        margin: 10,
                        padding: 10,
                      }}
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      placeholder="حداقل تعداد بازدید برای نمایش"
                      value={minValue}
                      onChange={handleMinValue}
                    />
                  </div>
                </>
              </div>
            </div>
            <div
              className="modal-footer"
              style={{ direction: 'ltr' }}
            >
              <button
                type="button"
                className="btn btn-secondary"
                id="closeFilterModal"
                data-bs-dismiss="modal"
              >
                بستن
              </button>
              <button
                className="btn btn-danger"
                onClick={handleResetFilters}
              >
                <i className="bi bi-reset me-2"></i>
                <span>ریست فیلترها</span>
              </button>
              <button
                onClick={handleSearchSubmit}
                type="button"
                className="btn btn-primary"
              >
                جستجو
              </button>
            </div>
          </div>
        </div>
      </div>
      {AllLandings.length ? (
        <>
          <div className={styles.DivShowLandings}>
            <div
              style={{ marginTop: 20 }}
              className={styles.TopOfTable}
            >
              <span
                className={styles.InfoCountTable}
              >{`نمایش ${metaPages.from} تا ${metaPages.to} از ${metaPages.total} مورد`}</span>

              <div
                style={{ flexWrap: 'wrap' }}
                className={styles.leftTop}
              >
                <Link
                  to="/dashboard/showLandings/trash-list"
                  style={{ marginLeft: '8px' }}
                >
                  <button className="btn btn-danger btn-sm">
                    <i className="bi bi-trash3-fill ms-1"></i>
                    <span>سطل زباله</span>
                  </button>
                </Link>

                <button
                  className="btn btn-success btn-sm"
                  data-bs-toggle="modal"
                  data-bs-target="#newUserModal"
                  style={{ color: 'white' }}
                >
                  <i className="bi bi-file-spreadsheet-fill me-2"></i>
                  <span>دانلود اکسل</span>
                </button>
                <DownloadExcelModal />
                <CopyLandingModal id={copyId} />
              </div>
            </div>
            <div className="table-responsive mx-2">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>ردیف</th>
                    <th>نام لندینگ</th>
                    <th>تعداد بازدید</th>
                    <th>نام قالب</th>
                    <th>آدرس</th>
                    <th>نوع</th>
                    <th>سازنده لندینگ</th>
                    <th>عملیات</th>
                  </tr>
                </thead>

                <tbody>
                  {AllLandings.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{metaPages.from + index}</td>
                        <td>{item.title}</td>
                        <td>
                          <Link
                            to={`/dashboard/visits?landing_id=${item.id}`}
                          >
                            {item.statistics_count}
                          </Link>
                        </td>
                        <td>{item.template?.title ?? 'حذف شده'}</td>
                        <td>
                          <Link
                            to={`${mainUrl}${item.slug}`}
                            target="_blank"
                          >
                            {item.slug}
                          </Link>
                        </td>
                        <td>
                          {item.is_automate ? 'اتوماتیک' : 'دستی'}
                        </td>
                        <td>
                          {item.user === null
                            ? 'حذف شده'
                            : `${item.user.first_name} ${item.user.last_name}`}
                        </td>

                        <td className={styles.amaliyatcol}>
                          <Link
                            to={`/dashboard/showLandings/edite/${item.id}`}
                            style={{ color: '#fff' }}
                          >
                            <button className="btn btn-dark btn-sm mx-1">
                              ویرایش
                            </button>
                          </Link>
                          <Link
                            to={`/dashboard/showLandings/${item.id}`}
                            style={{ color: '#fff' }}
                          >
                            <button className="btn btn-dark btn-sm mx-1">
                              جزئیات
                            </button>
                          </Link>
                          <Link
                            to={`/dashboard/showLandings/newofcopy/${item.id}`}
                            style={{ color: '#fff' }}
                          >
                            <button className="btn btn-dark btn-sm mx-1">
                              ایجاد کپی
                            </button>
                          </Link>
                          <button
                            onClick={() => setCopyId(item.id)}
                            className="btn btn-dark btn-sm mx-1"
                            data-bs-toggle="modal"
                            data-bs-target="#newCopyModal"
                            style={{ color: 'white' }}
                          >
                            کپی اتومات
                          </button>
                          <button
                            className="btn btn-danger btn-sm mx-1"
                            data-bs-toggle="modal"
                            data-bs-target={`#iam${index}`}
                          >
                            حذف
                          </button>

                          <ModalYesorNo
                            idModal={`iam${index}`}
                            doBtn="حذف"
                            text={`لندینگ ${item.title} حذف شود؟`}
                            Click={() =>
                              deleteTemplateHandler(item.id)
                            }
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {length !== 3 && (
              <MyPagination
                meta={metaPages}
                myPath={myPath}
                paginationHandler={paginationHandler}
                joinqueries={joinqueries}
              />
            )}
          </div>
        </>
      ) : (
        <ShowNothing text="لندینگی برای نمایش وجود ندارد" />
      )}
    </>
  ) : (
    <Loading color="#7545fb" />
  );
};

export default ShowLandings;
